import { LocaleEnum } from '@systemeio/ui'
import { getPublicPath } from 'shared/utils/locale/get-locale-for-link'

export const getHelpPageUrl = (dashboardLocale: LocaleEnum) => {
  return `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${
    process.env.NEXT_PUBLIC_SIO_HOST_NAME
  }${getPublicPath(dashboardLocale, '/help')}`
}
